import { gql } from "@apollo/client";

export const policyData = gql`
  fragment policyData on PolicyData {
    documentId
    insuranceTypeId
    insurerName
    insuredId
    clientId
    monthNo
    period
    directSettlementYn
    negotiatedQuotation
    insuranceAmount
    currencyCode
    startDate
    endDate
    insuranceDocumentSeries
    insuranceDocumentNumber
    paymentTypeId
    paymentDocumentSeries
    paymentDocumentNumber
    paymentDocumentDate
    otherInfo
    offerDetailId
    quotationId
    policyFileUniqueId
    clientSelectionConfirmedByUser
    financingContractNumber
  }
`;
